import lf from 'lovefield'

export function const_equipementsprestations (schemaBuilder) {
  schemaBuilder.createTable('const_equipementsprestations')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('libelle', lf.Type.STRING)
      .addColumn('commentaire', lf.Type.STRING)
      .addColumn('equipement', lf.Type.INTEGER)
      .addColumn('prestation', lf.Type.INTEGER)
      .addPrimaryKey(['id']);
}

/*
CREATE TABLE `const-equipementsprestations` (
  `id` int(11) NOT NULL,
  `equipement` tinyint(1) NOT NULL,
  `prestation` tinyint(1) NOT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constEquipementsprestations.schema.js